import {
	GROUPS_BY_TYPE_FETCH_REQUEST,
	GROUPS_BY_TYPE_FETCH_FAILURE,
	GROUPS_BY_TYPE_FETCH_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	groups: {},
};

export default function reducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case GROUPS_BY_TYPE_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
			};

		case GROUPS_BY_TYPE_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
			};

		case GROUPS_BY_TYPE_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				groups: {
					...state.groups,
					[payload.type]: payload.ids,
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/groupsByType.js